"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPromoteTool = createPromoteTool;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const promoteToIdea_1 = require("../../../app/dist/promoteToIdea");
const promoteToDesign_1 = require("../../../app/dist/promoteToDesign");
const promoteToPlan_1 = require("../../../app/dist/promoteToPlan");
const samplingAiClient_1 = require("../samplingAiClient");
const toolDef = {
    name: 'loom_promote',
    description: 'Promote a document to a new type (idea, design, or plan), creating a new doc linked to the source. Pass `body` to write the content yourself (skips MCP sampling) — this is the path to use in Claude Code, where server→client sampling is unavailable. Omit `body` to have the host generate it via sampling (VS Code / sampling-capable hosts only). For target type "plan" the body must contain a Steps table or a numbered Steps list.',
    inputSchema: {
        type: 'object',
        properties: {
            sourceId: { type: 'string', description: 'Source document id' },
            targetType: { type: 'string', enum: ['idea', 'design', 'plan'], description: 'Target document type' },
            targetWeaveId: { type: 'string', description: 'Optional target weave id (required when promoting from a global-level chat)' },
            targetThreadId: { type: 'string', description: 'Optional target thread id within the target weave' },
            title: { type: 'string', description: 'Optional title for the new doc (used with `body`). Defaults to the source doc title.' },
            body: { type: 'string', description: 'Optional inline markdown body (no frontmatter). When provided, sampling is skipped and this is written directly. Required in Claude Code sessions.' },
        },
        required: ['sourceId', 'targetType'],
    },
};
function createPromoteTool(server) {
    return {
        toolDef,
        async handle(root, args) {
            const sourceId = args['sourceId'];
            const targetType = args['targetType'];
            const targetWeaveId = args['targetWeaveId'];
            const targetThreadId = args['targetThreadId'];
            const title = args['title'];
            const body = args['body'];
            const { filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, sourceId);
            const deps = { loadDoc: dist_1.loadDoc, saveDoc: dist_1.saveDoc, fs, aiClient: (0, samplingAiClient_1.samplingAiClient)(server), loomRoot: root };
            const target = { targetWeaveId, targetThreadId, title, body };
            let result;
            if (targetType === 'idea') {
                result = await (0, promoteToIdea_1.promoteToIdea)({ filePath, ...target }, deps);
            }
            else if (targetType === 'design') {
                result = await (0, promoteToDesign_1.promoteToDesign)({ filePath, ...target }, deps);
            }
            else {
                result = await (0, promoteToPlan_1.promoteToPlan)({ filePath, ...target }, deps);
            }
            return { content: [{ type: 'text', text: JSON.stringify(result) }] };
        },
    };
}
